// removed by extract-text-webpack-plugin
module.exports = {"indent":"_3OoutmwkIJz4HVdCNayY_P","chartContent":"_3M49Ka25izFt2r0idiBDCB"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Statistics/ProjectRecipientStatistics/ProjectRecipientStatistics.scss
// module id = 1381
// module chunks = 1